import type { IndustryTemplatesResponse } from "@chat-yai/shared/admin-types";
import { request } from "@/api/client";

export const promptTemplatesApi = {
  list() {
    return request<IndustryTemplatesResponse>("/admin/prompts/templates");
  },
};
